export default '6.0.6';
